module.exports = __webpack_public_path__ + "files/85f98359294de7669327e84b47a32976.png";